import { r as registerInstance, c as createEvent, h, H as Host } from './index-16dc7dde.js';
import { d as debounce_1 } from './debounce-e28ac3ab.js';
import { m as myProductsResponseStatus } from './request.constants-deb285e0.js';
import { f as fetchers } from './lookups-705fb53e.js';
import { s as send, p as productSelectorAddToCartEvent } from './send-33ade633.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { N as NotificationBannerController } from './controller-0b53c447.js';
import { p as productsParamsToPostData } from './utils-c23b708f.js';
import { s as scConfigurationToPostData } from './product-selector-utils-92375719.js';
import { B as getSprykerBaseQueryParams } from './utils-15ad90ec.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { t as timeLimitedRequest } from './utils-62e3520b.js';
import './isObject-33fa1780.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './analytics-765d4daf.js';
import './_commonjsHelpers-ba3f0406.js';
import './utils-913bdf8a.js';
import './flatMap-bcae5f36.js';
import './_baseFlatten-2670ede5.js';
import './identity-6651b537.js';
import './isTypedArray-dfccd669.js';
import './toString-da636857.js';
import './_baseIteratee-506bcd8a.js';
import './_Uint8Array-2e849395.js';
import './_baseTimes-db8626dd.js';
import './_isIndex-af307327.js';
import './hasIn-6ce0da41.js';
import './types-aae419ee.js';
import './tslib.es6-2af8cb53.js';
import './currency-b61904e0.js';
import './noop-9247c8ef.js';
import './promise-74c80706.js';

const HIDE_TIMEOUT = 5000;

async function getMyProducts(host) {
  try {
    const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
    const response = await fetchers.getMyProducts({
      contextRoot,
      countryCode,
      languageCode,
    });
    if (response.lists.length === 0) {
      throw new Error('[FAVORITES] No favorites received');
    }
    return response.lists.map((productGroupShort) => (Object.assign(Object.assign({}, productGroupShort), { products: productGroupShort.products
        .map(Object.entries)
        .map(([[productId, quantity]]) => ({ productId, quantity })) })));
  }
  catch (error) {
    console.warn(error);
    return [];
  }
}
function scAddToCart(host, configurationEvent) {
  const payload = scConfigurationToPostData(configurationEvent);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
function addToMyProducts(host, productsParams) {
  const payload = productsParamsToPostData(productsParams);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
function deleteMyProducts(host, productsParams) {
  const { repositoryId, id } = productsParams;
  const idToDelete = repositoryId || (Array.isArray(id) ? id[0] : id);
  const params = { id: idToDelete };
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.deleteMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    params,
  });
}

const pesMyProductsConnectorCss = ":host{display:none}";

let PesMyProductsConnector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesGetMyProductsSucceeded = createEvent(this, "pesGetMyProductsSucceeded", 7);
    this.promiseRequest = null;
    this.myProductsGroupsCache = null;
    this.notificationElement = null;
    this.notificationController = new NotificationBannerController(HIDE_TIMEOUT);
    this.handleGetMyProducts = debounce_1(async () => {
      this.pesGetMyProductsSucceeded.emit(await this.getMyProducts());
    }, 200);
    this.handleButtonClick = () => {
      window.open(this.myProductsURL, '_self');
    };
  }
  async handleCtaDidClick(event) {
    const { type, product, bannerContext, onFinish, inList } = event.detail;
    let request;
    let notificationType;
    if (['favorites', 'cart'].includes(type)) {
      if (type === 'favorites' && inList) {
        request = this.handleRemoveFromList(product, onFinish);
        notificationType = "REMOVED_FROM_MY_PRODUCTS";
      }
      else {
        request = this.handleAddToList(product, onFinish);
        notificationType = type === 'favorites'
          ? "ADDED_TO_MY_PRODUCTS"
          : "ADDED_TO_CART";
      }
      const response = await request;
      if ((response === null || response === void 0 ? void 0 : response.status) === myProductsResponseStatus.SUCCESS) {
        this.showBanner(notificationType, bannerContext);
      }
    }
  }
  async handleSelectorAddToCart(event) {
    await this.handleScAddToCart(event.detail);
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.localeCode = (_a = tryParse(this._localeCode)) !== null && _a !== void 0 ? _a : this.localeCode;
    this.myProductsURL = (_b = tryParse(this._myProductsURL)) !== null && _b !== void 0 ? _b : this.myProductsURL;
    this.labels = (_c = tryParse(this._labels)) !== null && _c !== void 0 ? _c : this.labels;
    this.externalMyProducts = (_d = tryParse(this._externalMyProducts)) !== null && _d !== void 0 ? _d : this.externalMyProducts;
  }
  connectedCallback() {
    document.addEventListener('pesGetMyProducts', this.handleGetMyProducts);
  }
  disconnectedCallback() {
    document.removeEventListener('pesGetMyProducts', this.handleGetMyProducts);
  }
  attachListeners(el) {
    el === null || el === void 0 ? void 0 : el.addEventListener('actionDidClick', this.handleButtonClick);
  }
  async handleRemoveFromList(productData, onFinish) {
    const response = await timeLimitedRequest(deleteMyProducts)(this.localeCode, productData);
    if (typeof onFinish === 'function') {
      onFinish(response);
    }
    this.myProductsGroupsCache = null;
    return response;
  }
  async handleAddToList(productData, onFinish) {
    const response = await timeLimitedRequest(addToMyProducts)(this.localeCode, productData);
    if (typeof onFinish === 'function') {
      onFinish(response);
      this.myProductsGroupsCache = null;
    }
    return response;
  }
  sendScAnalytics(configurationEvent, response) {
    var _a, _b;
    const { productsUpdated, infoForGa } = response;
    const { products } = configurationEvent;
    const quantities = products.reduce((acc, product) => {
      const { productId, quantity } = product;
      acc[productId] = quantity;
      return acc;
    }, {});
    const mappedProducts = productsUpdated.map((id) => {
      const { description: name, brand = '', price = null } = infoForGa[id];
      return {
        id,
        brand,
        name,
        price,
        category: '',
        variant: '',
        quantity: quantities[id],
      };
    });
    const currencyCode = (_b = (_a = Object.values(infoForGa).find((product) => product.currency)) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : '';
    send(productSelectorAddToCartEvent, {
      currencyCode,
      distributor: '',
      products: mappedProducts,
    });
  }
  async handleScAddToCart(configurationEvent) {
    const response = await scAddToCart(this.localeCode, configurationEvent);
    const { status } = response;
    this.myProductsGroupsCache = null;
    if (isAnalyticsEnabled() && status === myProductsResponseStatus.SUCCESS) {
      this.sendScAnalytics(configurationEvent, response);
    }
    return this.showBanner("ADDED_TO_CART", 'body');
  }
  async showBanner(type, target) {
    const notificationElement = await this.notificationController.show({
      target,
      componentProps: this.getAllProps(type),
    });
    this.attachListeners(notificationElement);
  }
  getBannerContent(type) {
    switch (type) {
      case "ADDED_TO_CART":
        return {
          message: this.labels.addedToCart,
          btnMessage: this.labels.viewCart,
        };
      case "ADDED_TO_MY_PRODUCTS":
        return {
          message: this.labels.addedToMyProducts,
          btnMessage: this.labels.viewMyProducts,
          type,
        };
      case "REMOVED_FROM_MY_PRODUCTS":
        return {
          message: this.labels.removedFromMyProducts,
          type,
        };
      default:
        return {};
    }
  }
  getAllProps(type) {
    const actions = {};
    const bannerContent = this.getBannerContent(type);
    if (bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.btnMessage) {
      actions.primary = {
        label: bannerContent.btnMessage,
      };
    }
    return {
      active: true,
      status: "warning",
      actions,
      innerHTML: bannerContent.message,
    };
  }
  async getMyProducts() {
    var _a;
    if (this.isExternalConsumer && this.externalMyProducts) {
      this.myProductsGroupsCache = this.externalMyProducts || [];
      this.promiseRequest = null;
      return this.myProductsGroupsCache;
    }
    if (!this.myProductsGroupsCache && !window.isAsco) {
      this.promiseRequest = (_a = this.promiseRequest) !== null && _a !== void 0 ? _a : getMyProducts(this.localeCode);
      this.myProductsGroupsCache = await this.promiseRequest;
    }
    this.promiseRequest = null;
    return this.myProductsGroupsCache;
  }
  componentDidLoad() {
    {
      this.getMyProducts();
    }
  }
  render() {
    return h(Host, null);
  }
};
PesMyProductsConnector.style = pesMyProductsConnectorCss;

export { PesMyProductsConnector as pes_my_products_connector };
